import { useRendererContext } from '@turiya/orchestrator-renderer-react';
import { createContext } from 'react';
import { GLOBAL_SEARCH_CASE } from '../../../common/model';

export interface CaseHistoryData {
    processInstanceId: string;
    businessKey: string;
    variables: {
        ckycReferenceNumber: string | null;
        notifiedToCkycDate: string | null;
        triggerDate: string | null;
        downloadDate: string | null;
        ckycIdGenerationDate: string | null;
        firstBatchUploadDate: string | null;
        searchDate: string | null;
        searchParameter: string;
        ckycNumber: string | null;
        customerName: string | null;
        ckycStatus: string;
        res1Date: string | null;
        manualReviewFlag: boolean;
        failureReason: string | null;
        status: string;
        ckycOperationId: string | null;
        losAppId: string | null;
        ucic: string | null;
    };
}

interface CaseHistoryContextType {
    getCaseHistory: (clientId: string, searchId: string, searchIdType: string) => Promise<CaseHistoryData>;
}

export const CaseHistoryContext = createContext<CaseHistoryContextType>({
    getCaseHistory: () => Promise.resolve({} as CaseHistoryData),
});

export const CaseHistoryProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const { getEngineApi } = useRendererContext();

    const getCaseHistory = async (
        clientId: string,
        searchId: string,
        searchIdType: string,
    ): Promise<CaseHistoryData> => {
        const response = await getEngineApi()?.startWithMessage(GLOBAL_SEARCH_CASE, {
            clientName: clientId,
            searchId: searchId,
            searchIdType: searchIdType,
        });
        return response as CaseHistoryData;
    };

    return (
        <CaseHistoryContext.Provider value={{ getCaseHistory: getCaseHistory }}>{children}</CaseHistoryContext.Provider>
    );
};
